export const INSURANCE_TYPE = {
    ALL: 0,
    LIFE: 1,
    SONPO: 2,
};

const insuranceTypes = {
    [INSURANCE_TYPE.LIFE]: { name: '生命保険', shortName: '生保', tabName: 'life' },
    [INSURANCE_TYPE.SONPO]: { name: '損害保険', shortName: '損保', tabName: 'sonpo' },
};

/**
 * ドキュメント種別の定義
 */
export const DOCUMENT_TYPE = {
    POLICY_BOOKLET: 'policy_booklet',
    NEW_CONTRACT: 'new_contract',
    MAINTENANCE: 'maintenance',
    HANDBOOK: 'handbook',
    HIKIUKE: 'hikiuke',
    ALL: 'all', // 「すべて」選択時の文書種別コード（未選択は ''）
};

/**
 * 保険タイプの名前を取得する関数
 * @param {number} type - 保険タイプの数値
 * @returns {string} - 保険タイプの名前
 */
export const getInsuranceTypeName = (type) => {
    if (type === null) {
        return '保険';
    }
    return insuranceTypes[type] ? insuranceTypes[type].name : '';
};

/**
 * 文書種別の表示名を取得する関数 
 * @param {number} insuranceType - 保険種別値
 * @param {string} documentType - 文書種別名
 * @param {string} documentTypeName - 文書種別の表示名
 * @returns {string} - 文書種別の表示名
 */
export const getDocumentTypeName = (insuranceType, documentType, documentTypeName) => {
    if (documentType === DOCUMENT_TYPE.ALL) {
        return Number(insuranceType) === INSURANCE_TYPE.LIFE ? 'すべて(引受目安以外)' : 'すべて';
    }
    return documentTypeName;
};


/**
 * 保険タイプの略称を取得する関数
 * @param {number} type - 保険タイプの数値
 * @returns {string} - 保険タイプの略称
 */
export const getInsuranceTypeShortName = (type) => {
    return insuranceTypes[type] ? insuranceTypes[type].shortName : '';
};

/**
 * 保険タイプのタブ名を取得する関数
 * @param {number} type - 保険タイプの数値
 * @returns {string} - 保険タイプのタブ名
 */
export const getInsuranceTypeTabName = (type) => {
    return insuranceTypes[type] ? insuranceTypes[type].tabName : '';
}

const tabNameToTypeMap = {
    'life': INSURANCE_TYPE.LIFE,
    'sonpo': INSURANCE_TYPE.SONPO,
};

/**
 * tabNameから保険タイプの数値を取得する関数
 * @param {string} tabName - タブ名
 * @returns {number} - 保険タイプの数値
 */
export const getInsuranceTypeFromTabName = (tabName) => {
    if (tabName === '') {
        return null; // 選択なしの場合はnullを返す
    }
    return tabNameToTypeMap[tabName] || INSURANCE_TYPE.ALL;
};

const documentTypes = {
    [INSURANCE_TYPE.LIFE]: ['しおり・約款', '新契約関連', '保全・収納・支払関連', '引受目安'], // 生命保険
    [INSURANCE_TYPE.SONPO]: ['しおり・約款', 'ハンドブック'], // 損害保険
};

/**
 * 保険タイプに応じたドキュメントタイプの選択肢を取得する関数
 * @param {number} type - 保険タイプの数値
 * @returns {string[]} - ドキュメントタイプの選択肢
 */
export const getDocumentTypeOptions = (type) => {
    return documentTypes[type] || [];
};

const productTypes = {
    [INSURANCE_TYPE.LIFE]: ['死亡保険', '医療保険', 'がん・生活習慣病・特定疾病保険', '介護・認知症・就業不能保険', '年金・学資保険', '変額保険', '外貨建保険', 'その他'], // 生命保険
    [INSURANCE_TYPE.SONPO]: ['自動車・バイク', '火災・地震', '傷害', '旅行・レジャー', 'ペット', '第三分野・所得補償', 'その他'], // 損害保険
};

/**
 * 保険タイプに応じた保険商品種類の選択肢を取得する関数
 * @param {number} type - 保険タイプの数値
 * @returns {string[]} - 保険商品種類の選択肢
 */
export const getProductTypeOptions = (type) => {
    return productTypes[type] || [];
};
